import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Kõik %s

  <span style="color:#85c1dc;">**FI:**</span>
  Kaikki %s

  <span style="color:#85c1dc;">**RU:**</span>
  Все %s
*/
/* @__NO_SIDE_EFFECTS__ */
const m555 = msg(
  mf`Kõik %s`,
  mf`Kaikki %s`,
  mf`Все %s`,
)

export { m555 as 'w.header.menu.view-all' }